// Use the native method `filter` to loop through the array and leave only those entries that pass the given callback function onlyUnique.
// onlyUnique checks, if the given value is the first occurring. If not, it must be a duplicate and will not be copied.
// https://stackoverflow.com/a/14438954/19588
export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}


export function isArray(obj) {
    if (typeof Array.isArray !== 'undefined') return Array.isArray(obj);
    return Object.prototype.toString.call(obj) === '[object Array]';
}


// https://stackoverflow.com/a/62888478/19588
export function interweave(array1, array2) {
    const longest = array1.length > array2.length ? array1 : array2;
    const shortest = array1.length > array2.length ? array2 : array1;
    const ratio = Math.floor(longest.length / shortest.length);
    const results = [];
    for (let i = 0; i < shortest.length; i++) {
        for (let j = 0; j < ratio; j++) {
            results.push(longest[i * ratio + j]);
        }
        results.push(shortest[i]);
    }
    // Grab any that are left over
    for (let i = longest.length - (longest.length % shortest.length); i < longest.length; i++) {
        results.push(longest[i]);
    }
    return results;
}


// https://stackoverflow.com/a/2450976/19588
export function shuffle(array) {
    let currentIndex = array.length,  randomIndex;

    // While there remain elements to shuffle...
    while (currentIndex != 0) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }

    return array;
}

